import React from "react";
import "./Search.css";
import NavBarItem from "../home/NavbarComponent/NavBarItem";
import Footer from "../home/FooterComponent/FooterComponent";
import SearchPopup from "./SearchPopupComponent/SearchPopup";
import SearchList from "./SearchListComponent/SearchList";
const Search = () => {
  return (
    <div className="search-page">
      <NavBarItem />
      <div className="search-container-page">
        <SearchPopup />
        <SearchList />
      </div>

      <Footer />
    </div>
  );
};

export default Search;
